import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import { Tooltip } from 'investira.react.components';

const Warp = styled('span')(() => ({
  display: 'inline-block',
  position: 'relative',
  pointerEvents: 'visible',
  verticalAlign: 'top',
  border: 0,
  margin: 0,
  padging: 0
}));

/**
 * Renderiza o componente MutedCopy.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {*|string|number} props.value - Valor exibido ou controlado pelo componente.
 * @returns {JSX.Element} Elemento renderizado pelo componente.
 */
function MutedCopy(props) {
  const [tooltip, setTooltip] = useState('Copiar');

  let body = document.getElementsByTagName('body')[0];

  let timeout = useRef(null);

  const copyToClipboard = (pValue, pEvent) => {
    if (!pValue) return;
    pEvent.preventDefault();
    pEvent.stopPropagation();
    const tempInput = document.createElement('input');
    body.appendChild(tempInput);
    tempInput.setAttribute('value', pValue.toString());
    tempInput.select();
    document.execCommand('copy');
    body.removeChild(tempInput);

    setTooltip('COPIADO!');
  };

  useEffect(() => {
    timeout.current = setTimeout(() => {
      setTooltip(props.title || 'Copiar');
    }, 3000);
  }, [props.title, tooltip]);

  useEffect(() => {
    props.title && setTooltip(props.title);
    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return (
    <Tooltip title={tooltip} placement="top">
      <Warp onClick={e => copyToClipboard(props.value, e)}>{props.children}</Warp>
    </Tooltip>
  );
}

MutedCopy.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};

export default MutedCopy;
